<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(saveCompanyInformation)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px"><b>Registro Compañia</b></p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errores">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                        </ul>
                    </b-alert>
                    
                    <company-data-form :formData="formData" :permissions="permissions" />
                    <hr />
                    <user-master-form :formData="formData" />

                    <hr />
                    <branch-data-form :formData="formData" />
                    
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Registrar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import UserMasterForm from '../components/UserMasterForm.vue';
import CompanyDataForm from '../components/CompanyDataForm.vue';
import BranchDataForm from '../components/BranchDataForm.vue';
export default {
    computed: {
        ...mapState('configuration', ['tipoDocumentoCliente'])
    },
    data(){
        return{
            formData: {
                companyNit: "",
                companyName:  "",
                identificationDocumentType: '',
                identificationDocumentNumber: '',
                userName: "",
                userEmail: "",
                userPhoneNumber: "",
                userAddress: "",
                userProvince_id: "",
                userCity_id: "",
                branchName: "",
                branchAddress: "",
                branchPhoneNumber: "",
                branchProvince_id: "",
                branchCity_id: "",
            },
            errors: {},
            errores: false,
            departamentos_list: [],
            ciudades_list: [],
            permissions: {},
        }
    },
    components: {
        UserMasterForm,
        CompanyDataForm,
        BranchDataForm
    },
    created(){
        this.getDepartamentosList();
    },
    methods: {
        ...mapMutations(['setLoading']),
        back(){
            this.$router.go(-1);
        },
        async saveCompanyInformation(){
            this.errors = {};
            this.errores = false;
            this.setLoading(true)
            let permissionArray = Object.keys(this.permissions).filter(key => this.permissions[key]);
            this.formData.permissions = permissionArray;
            await this.$conectar.post('/admin/empresas/save-company-information', this.formData)
            .then(response=>{
                if(response.data.error == true){
                    this.errores = true;
                    this.errors = response.data.errors;
                }else{
                    this.$root.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'companiesList' });
                }
            })
            .catch(response =>{
                console.log(response);
                this.$root.$bvToast.toast("Error en el servidor, favor intente nuevamente", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentos_list = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            this.ciudad = '';
            this.departamentoSelected = { 
                departamento_id:   this.departamento, 
            }
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
            .then(response =>{
                this.ciudades_list = response.data.ciudadesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
    }
    
}
</script>